import React, { PureComponent } from 'react';
import styled from 'styled-components';

import LOGO from 'core/assets/images/logo.png';

class Logo extends PureComponent {
  render() {
    return (
      <Image src={LOGO} />
    );
  }
}

export default Logo;

const Image = styled.div`
  margin: 20px auto;
  width: 113px;
  height: 113px;
  background-image: url(${LOGO});
  background-size: cover;
`;
